import * as React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import ROUTERS from '../constans/router';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const  PublicRouter = ({ isAuth }) => {
    const query = useQuery()
    return <>{isAuth ? <Navigate to={query.get('redirect') || ROUTERS.HOME} /> : <Outlet />}</>;
};

export default PublicRouter;
